import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";

// components
import Loader from "../../../components/loader";
import Model from "../../../components/customModal";
import MakeAPICall from "../../../apiCalls/common";

import Label from "../../../components/label";
import ICSelect from "../../../components/form/selectInput";

// api routes
import { accessMIMSTokenApiRoute, addConsultNoteStep1ApiRoute } from "../../../apiRoutes";
import { saveDrugInfo, saveNoteAttachment, updateEbsNumber } from "../../../reduxStore/actions/auth";

// utilities
import * as MIMSUtils from "../../../utils/MIMSUtil";

// E prescription form
import EPrescriptionForm from "./EPrescribingForm";
import Anchor from "../../../components/anchor";

const DRUG_DATA = {
    "Minoxidil" : {sideEffects: "skin irritation, itching, redness, dryness and flaking to the treated area of the scalp", halfLife: '', isOverTheCounter: true},
    "Finasteride" : {sideEffects: "decreased libido, erectile dysfunction, premature ejaculation, skin rash ", halfLife: "5-6 hours"},
    "Melatonin (Circadin)" : {sideEffects: "headache, dizziness, nausea and drowsiness", halfLife: "4 hours"},
    "Dapoxetine" : {ielt: "2.5-3", sideEffects: "nausea, diarrhoea, headache, somnolence and dizziness", halfLife: "1.5 hours"},
    "Paroxetine" : {ielt:"11.6", sideEffects: "insomnia, anxiety, nausea, loss of libido, erectile dysfunction and anhidrosis", halfLife: "21 hours"},
    "Fluoxetine" : {ielt:"5", sideEffects: "insomnia, anxiety, nausea, loss of libido, erectile dysfunction and anhidrosis", halfLife: "36 hours"},
    "Sertraline" : {ielt:"5", sideEffects: "insomnia, anxiety, nausea, loss of libido, erectile dysfunction and anhidrosis", halfLife: "26 hours"},
    "Clomipramine" : {ielt:"6", sideEffects: "nausea, dry mouth, erectile dysfunction, hot flushes, arrhythmias", halfLife: "19-37 hours"},
    "Sildenafil" : {sideEffects: "headache, flushing, dyspepsia, nasal congestion and abnormal vision", halfLife: "4 hours"},
    "Tadalafil" : {sideEffects: "headache, dyspepsia, back ache and myalgia, flushing and nasal congestion", halfLife: "18 hours"},
    "Avanafil" : {sideEffects: "headache, flushing, dyspepsia, nasal congestion and dizziness", halfLife: "5 hours"},
    "Vardenafil" : {sideEffects: "headache, flushing, dyspepsia, nasal congestion and abnormal vision", halfLife: "4 hours"},
};
const Prescription = (props) => {
    const [loading, setIsLoading] = useState(false);
    const [apiCallParams, setApiCallParams] = useState(null); // api call

    const [dataForPrescribingForm, setDataForPrescribingForm] = useState(null);

    // MIMS token to get the drug data
    const [MIMSToken, setMIMSToken] = useState("");
    const [MIMSTokenExpiryTimestamp, setMIMSTokenExpiryTimestamp] = useState("");

    // generic model to display error message
    const [showTextModal, setShowTextModal] = useState(false);
    const [modalText, setModalText] = useState("");

    const [isConfirmationModelOpen, setIsConfirmationModelOpen] = useState(false);
    const [submitFormValues, setSubmitFormValues] = useState(null);
    const [drugInfo, setDrugInfo] = useState(null);
    const [isScriptOwing, setIsScriptOwing] = useState(false);

    // for adding a drug into selected type - this is custom array of selected types
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [currentSelectedTypeOnDropDown, setCurrentSelectedTypeOnDropDown] = useState('');

    const getMIMSToken = () => {
        setIsLoading(true);
        let apiCallParam = {
            reqType: "GET",
            reqURL: accessMIMSTokenApiRoute,
            dataObj: {},
            params: {},
            headers: {},
            successCallback: res => {
                setIsLoading(false);
                let MIMSToken = res.data.data.access_token;
                let MIMSTokenExpiryTimestamp = MIMSUtils.setMIMSTokenExpiredTime(
                    res.data.data.expires_in
                );
                localStorage.setItem("MIMS-token", MIMSToken);
                localStorage.setItem("MIMS-token-expired", MIMSTokenExpiryTimestamp);
                setMIMSToken(MIMSToken);
                setMIMSTokenExpiryTimestamp(MIMSTokenExpiryTimestamp);
            },
            failureCallback: err => {
                setIsLoading(false);
                console.error(err);
                // setModalText(
                //     "Something wrong with MIMS token. Please try to reload page again"
                // );
                // setShowTextModal(true);
            },
            showPopUp: false
        };
        setApiCallParams(apiCallParam);
    }

    const setEPrescribingFormData = () => {
        console.log("Prescription Page Props: ", props);
        const doctorDetails = props.auth.userData;
        const patientDetails = props.assessmentData.patientId;
        const data = {
            doctorDetails: doctorDetails,
            patientDetails: patientDetails
        };
        setDataForPrescribingForm(data);
    }


    // get MIMS token first
    useEffect(() => {
        let MIMSToken = localStorage.getItem("MIMS-token");
        let MIMSTokenExpiryTimestamp = localStorage.getItem("MIMS-token-expired");
        let isMIMSTokenValid = MIMSUtils.validateMIMSToken(
            MIMSToken,
            MIMSTokenExpiryTimestamp
        );

        if (isMIMSTokenValid) {
            setMIMSToken(MIMSToken);
            setMIMSTokenExpiryTimestamp(MIMSTokenExpiryTimestamp);
        } else {
            getMIMSToken();
        }

        setEPrescribingFormData();
    }, []);

    const onDocSaveSubmit = (formValues, drugDataToSave) => {
        setIsConfirmationModelOpen(true);
        setDrugInfo(drugDataToSave);
        setSubmitFormValues(formValues);

    };

    const onDocFormSubmit = (formValues, isSave = false) => {
        setIsLoading(true);
        let apiCallParam = {
            reqType: "POST",
            reqURL: addConsultNoteStep1ApiRoute,
            dataObj: formValues,
            params: {},
            headers: {},
            successCallback: res => {
                setIsLoading(false);

                console.log("Got the save note attachment: ", {
                    type: "Prescription",
                    url: res.data.data.url
                });

                if (window && isSave === false) {
                    window.open(res.data.data.url);
                } else {

                    const typesInfo = props.selectedType;

                    props.saveNoteAttachment({
                        type: "Prescription",
                        url: res.data.data.url,
                        selectedTypes: currentSelectedTypeOnDropDown,
                        drugInfo: drugInfo,
                        urlObjectId: res.data.data._id,
                        drugName: res.data.data.drugName
                    });

                    let drugInfoCopy = JSON.parse(JSON.stringify(drugInfo));
                    drugInfoCopy["url"] = res.data.data.url;

                    appendDrugHalfLifeAndSideEffects(drugInfoCopy)
                    if (typesInfo[currentSelectedTypeOnDropDown]['drugs']) {
                        typesInfo[currentSelectedTypeOnDropDown]['drugs'].push(drugInfoCopy);
                    } else {
                        typesInfo[currentSelectedTypeOnDropDown]['drugs'] = [drugInfoCopy];
                    }


                    console.log("Now saving this info: ", typesInfo);

                    // saving drug info which will be used in other api, we will (probably) use during submitting assessment
                    props.saveDrugInfo(typesInfo);


                    // update ebsnumber if the prescription used PBS authority number
                    if (props.auth.isPBSAuthorityRequired) {
                        let updatedEbsNumber;
                        if (props.auth.userData.ebsnumber) {
                            updatedEbsNumber = Number(props.auth.userData.ebsnumber) + 1;
                        } else {
                            let prescriberNo = props.auth.userData.prescriberNo;
                            let prescriberNoArr = prescriberNo.substr(
                                prescriberNo.length - 5,
                                4
                            );
                            updatedEbsNumber = Number(prescriberNoArr);
                        }
                        props.updateEbsNumber(updatedEbsNumber);
                    }

                    props.togglePrescriptionComponent();
                    setSubmitFormValues(null);
                }
            },
            failureCallback: err => {
                setIsLoading(false);
                // setModalText(
                //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                // );
                // setShowTextModal(true);
            },
            showPopUp: false
        };
        setApiCallParams(apiCallParam);
    };

    function appendDrugHalfLifeAndSideEffects(drugDataToSave) {
        const keys = Object.keys(DRUG_DATA);
        const values = Object.values(DRUG_DATA);
        for (let i = 0; i < keys.length; i++) {
            if (drugDataToSave.name?.includes(keys[i])){
                Object.entries(values[i]).forEach(([key, value])=> {
                    drugDataToSave[key] = value;
                    // formData.append(key, value)
                })
                break;
            }
        }
        console.log(drugDataToSave)
    }

    const submitDocument = () => {
        setIsConfirmationModelOpen(false);
        onDocFormSubmit(submitFormValues, true);
    };

    const closeConfirmationModel = () => {
        setIsConfirmationModelOpen(false);
    };

    useEffect(() => {
        if (props.selectedType) {
            console.log("Selected Types");
            let selections = [];
            props.selectedType.map((types, index) => {
                const key = index;
                const value = types.typeName === "Hair Loss"? `${types.typeName} :  ${types.drug}` + (types.brand? ` - ${types.brand}` : ''):
                  `${types.typeName} ${(types.combinationTherapyType ? ' - ' + types.combinationTherapyType : '')} ${(types.drug ? ': ' + types.drug : '')}`
                selections.push({
                    _id: key,
                    val: value
                });
            });
            setSelectedTypes(selections);
            setCurrentSelectedTypeOnDropDown(0);
        }
    }, [props.selectedType])

    function getSelectedType(){
        switch (props.assessmentData.assessmentType) {
            // case 'Medicinal Cannabis':
            //     return <div className="container-fluid mt-3 mb-3">
            //         <Label title="Selected Type" className="secondary-font w-100" />
            //         <Label title="Medicinal Cannabis" className="w-100" />
            //         <Label title="Search Catalyst™ Medicines Database for available products:" className="secondary-font" />
            //         <Anchor
            //           title="Open Catalyst"
            //           href="https://catalyst.honahlee.com.au/app/products"
            //           className="insta-link-orange secondary-font font-15 p-2"
            //           target="_blank"
            //         />
            //     </div>
            case "Medicinal Cannabis":
                return <div className="container-fluid mt-3 mb-3">
                    <Label title="Selected Type" className="secondary-font w-100" />
                    <ICSelect
                        label=""
                        id="selectedTypes"
                        name="selectedTypes"
                        useId="_id"
                        useValue="val"
                        className="auto-width"
                        disabled={selectedTypes.length === 1}
                        items={selectedTypes}
                        value={currentSelectedTypeOnDropDown}
                        handleChange={val => {
                            console.log("Handle change: ", val);
                            setCurrentSelectedTypeOnDropDown(val);
                        }}
                    />
                    <div class="mt-2">
                    <Label title="Search Catalyst™ Medicines Database for available products:" className="secondary-font" />
                    <Anchor
                            title="Open Catalyst"
                            href="https://catalyst.honahlee.com.au/app/products"
                            className="insta-link-orange secondary-font font-15 p-2"
                            target="_blank"
                    />
                    </div>
                </div>

            default:
                return <div className="container-fluid mt-3 mb-3">
                    <Label title="Selected Type" className="secondary-font w-100" />
                    <ICSelect
                      label=""
                      id="selectedTypes"
                      name="selectedTypes"
                      useId="_id"
                        className="auto-width"
                      useValue="val"
                      disabled={selectedTypes.length === 1}
                      items={selectedTypes}
                      value={currentSelectedTypeOnDropDown}
                      handleChange={val => {
                          console.log("Handle change: ", val);
                          setCurrentSelectedTypeOnDropDown(val);
                      }}
                    />
                </div>
        }
    }

    function shouldHideS8(){
        switch (props.assessmentData.assessmentType) {
            case 'Medicinal Cannabis':
          return true
            default:
           return false
        }
    }

    return (
        <Fragment>
            <Loader loading={loading} className="loading-overwride" />
            <div className="container-fluid mt-3">
                <Label title="Add Prescription" className="secondary-font w-100" />
            </div>

            {getSelectedType()}

            {
                dataForPrescribingForm && MIMSToken && <EPrescriptionForm
                    assessmentData={props.assessmentData}
                    data={dataForPrescribingForm}
                    onSaveSubmit={onDocSaveSubmit}
                    hideS8={shouldHideS8()}
                    onPreviewSubmit={onDocFormSubmit}
                    MIMSToken={MIMSToken}
                    MIMSTokenExpiryTimestamp={MIMSTokenExpiryTimestamp}
                    setIsScriptOwing={setIsScriptOwing}
                    doctorData={props.auth.userData}
                    />
            }

            {/* Generic model to display error message */}
            <Model
                useOneButton={true}
                cancelText="Okay"
                openModal={showTextModal}
                cancelEvent={() => {
                    setShowTextModal(false);
                    setModalText("");
                }}
                modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
            />

            {/* Confirmation Form  */}
            <Model
                openModal={isConfirmationModelOpen}
                modalBodyContent={
                    <p className="text-center mb-0">
                        You are unable to edit this document once saved.
                        <br /> Do you still want to save?
                    </p>
                }
                okayText="Save"
                cancelText="Cancel"
                title="Instant Consult"
                useOneButton={false}
                okayEvent={submitDocument}
                cancelEvent={closeConfirmationModel}
            />

            {/* API Call */}
            <MakeAPICall apiParam={apiCallParams} />
        </Fragment>
    )
};

// get the store
const mapStateToProps = props => ({
    auth: props.auth.user
});

const mapDispatchToProps = dispatch => ({
    // setOnlineAssessmentStatus: data => dispatch(setOnlineAssessmentStatus(data))
    updateEbsNumber: data => dispatch(updateEbsNumber(data)),
    saveNoteAttachment: data => dispatch(saveNoteAttachment(data)),
    saveDrugInfo: data => dispatch(saveDrugInfo(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Prescription);


